module.exports = __webpack_public_path__ + "static/media/brownie.d8a88e31.jpg";